<template>
  <div>
    <b-tabs
      v-if="!isHonorario"
      end
    >
      <div
        v-for="(servicosPorDep) in valueInner"
        ref="servicos"
        :key="servicosPorDep.departamento.id"
      >
        <b-tab
          v-if="servicosPorDep.servicos.length > 0"
          :title="servicosPorDep.departamento.nome"
        >
          <tabela-servicos
            :ref="`servicospordepartamento${servicosPorDep.departamento.id}`"
            :value="servicosPorDep.servicos"
            :colunas="colunasServico"
            :mostrar-selecionados="mostrarSelecionados"
            @servico-selecionado="servicoSelecionado($event)"
            @servico-atualizado="servicoAtualizado($event)"
            @todos-selecionado="todosSelecionado($event)"
          />
        </b-tab>
      </div>
      <slot name="valor-total" />
    </b-tabs>
    <div
      v-else
    >
      <tabela-servicos
        ref="servicoshonorarios"
        :value="servicohonorariochecklist()"
        :colunas="colunasServico"
        :mostrar-selecionados="mostrarSelecionados"
        @servico-selecionado="servicoSelecionado($event)"
        @servico-atualizado="servicoAtualizado($event)"
        @todos-selecionado="todosSelecionado($event)"
      />
      <slot name="valor-total" />
    </div>
  </div>
</template>

<style lang="scss">
.valor-total {
  float: right;
  width: 23.2rem;
  font-size: 16px;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
export default {
  name: 'ServicoDepartamento',
  components: {
    TabelaServicos: () => import('@/app-modulo/comercial/pacote-servico/shared/components/tabela-servicos/TabelaServicos.vue'),
  },
  props: {
    value: {
      type: [Object, Array],
      default: () => { },
    },
    aplicarFiltro: {
      type: Boolean,
      default: false,
    },
    mostrarSelecionados: {
      type: Boolean,
      default: false,
    },
    valorTotal: {
      type: Number,
      default: 0,
    },
    isHonorario: {
      type: Boolean,
      default: false,
    },
    servicosComHonorario: {
      type: [Object, Array],
      default: () => { },
    },
  },
  data() {
    return {
      colunasServico: [
        { label: 'Nome', field: 'nome', sortable: false },
        { label: 'Benefício', field: 'beneficio', sortable: false },
        { label: 'Incluir no contrato', field: 'incluirNoContrato', sortable: false },
        {
          label: 'Valor',
          field: 'valorAuditar',
          sortable: false,
          width: '200px',
          type: 'decimal',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
      ],
      value_: null,
      filtrar: false,
      valor_: 0,
      valorRCC_: 0,
      servicosSelecionadosIndividual: [],
    }
  },
  computed: {
    valueInner: {
      get() {
        return this.value_
      },
      set(value) {
        this.value_ = value
      },
    },
    valor: {
      get() {
        return this.valor_
      },
      set(value) {
        this.valor_ = value
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.valueInner = value
      }
    },
    aplicarFiltro(value, oldValue) {
      if (value && value !== oldValue) {
        this.filtrar = value
      }
    },
    valorTotal(value, oldValue) {
      if (value && value !== oldValue) {
        this.valor = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.valor = this.valorTotal
  },
  methods: {
    getValorServico(servico) {
      return servico && servico.beneficio ? 0 : servico.valorAuditar
    },
    getValorRCCServico(servico) {
      return servico && servico.beneficio ? 0 : servico.valorRCC
    },
    getServicosSelecionados() {
      if (this.isHonorario) {
        return Array.isArray(this.servicosComHonorario)
          ? this.servicosComHonorario.filter(s => s && s.vgtSelected)
          : []
      }

      if (!Array.isArray(this.valueInner)) {
        return []
      }

      return this.valueInner
        .flatMap(dep => (dep.servicos || []))
        .filter(s => s && s.vgtSelected)
    },
    recalcularTotais() {
      const selecionados = this.getServicosSelecionados()
      this.valor = selecionados.reduce((acc, serv) => acc + this.getValorServico(serv), 0)
      this.valorRCC_ = selecionados.reduce((acc, serv) => acc + this.getValorRCCServico(serv), 0)
      this.$emit('valor-total', { valor: this.valor, valorRCC: this.valorRCC_ })
    },
    servicoSelecionado(selecionado) {
      if (selecionado.vgtSelected) {
        if (!this.isHonorario) {
          this.servicosSelecionadosIndividual.push(selecionado.servicoId)
        }
      } else {
        const indexServico = this.servicosSelecionadosIndividual.indexOf(selecionado.servicoId)
        if (!this.isHonorario && indexServico !== -1) {
          this.servicosSelecionadosIndividual.splice(indexServico, 1)
        }
      }

      this.recalcularTotais()
      this.$emit('selecionado-servico', selecionado)
    },
    servicoAtualizado() {
      this.recalcularTotais()
    },
    todosSelecionado(selecionados) {
      if (selecionados.length > 0) {
        selecionados.forEach(sel => {
          if (sel.vgtSelected && !this.servicosSelecionadosIndividual.includes(sel.servicoId)) {
            if (!this.isHonorario) {
              this.servicosSelecionadosIndividual.push(sel.servicoId)
            }
          }
        })
      } else if (this.isHonorario) {
        this.servicosSelecionadosIndividual = []
      } else {
        this.valueInner.forEach(fo => fo.servicos.forEach(this.diminuirValor))
      }
      this.recalcularTotais()
    },
    diminuirValor(servico) {
      if (servico.selecionadoAntes && !servico.vgtSelected) {
        const indexServico = this.servicosSelecionadosIndividual.indexOf(servico.servicoId)
        if (!this.isHonorario && indexServico !== -1) {
          this.servicosSelecionadosIndividual.splice(indexServico, 1)
        }
        this.$set(servico, 'selecionadoAntes', false)
      }
    },
    servicohonorariochecklist() {
      if (!Array.isArray(this.servicosComHonorario)) {
        return []
      }
      return this.servicosComHonorario
    },
  },
}
</script>
